import { render, staticRenderFns } from "./parrainage.component.vue?vue&type=template&id=575adca9&scoped=true"
import script from "./parrainage.component.vue?vue&type=script&lang=js"
export * from "./parrainage.component.vue?vue&type=script&lang=js"
import style0 from "./parrainage.component.vue?vue&type=style&index=0&id=575adca9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575adca9",
  null
  
)

export default component.exports